import React, { createContext, useContext, useState } from 'react';

type DnDContextType = [any, React.Dispatch<React.SetStateAction<any>>];

const DnDContext = createContext<DnDContextType>([null, () => {}]);

export const DnDProvider = ({ children }: { children: React.ReactNode }) => {
  const [newNode, setNewNode] = useState(null);

  return (
    <DnDContext.Provider value={[newNode, setNewNode]}>
      {children}
    </DnDContext.Provider>
  );
};

export default DnDContext;

export const useDnD = () => {
  return useContext(DnDContext);
};
